import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-bone py-12 sm:py-20" aria-labelledby="guarantee-title" data-id="element-103" data-mp="4uqdmw6js2tb">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-8" data-id="element-104" data-mp="9umh8ubc1s8c">
        <div className="flex flex-col items-center gap-5 rounded-3xl border border-gold/30 bg-ivory px-5 py-8 text-center sm:gap-6 sm:px-10 sm:py-10" data-id="element-105" data-mp="9t1nv80r8fc2">
          <span className="flex h-16 w-16 items-center justify-center rounded-full border border-gold/40 bg-gold-pale" aria-hidden data-id="element-106" data-mp="jt26ssupotfq">
            <ShieldCheckIcon className="h-7 w-7 text-gold-deep" data-id="element-107" data-mp="nrrkynnkqf0f" />
          </span>
          <h2 id="guarantee-title" className="font-display text-[1.35rem] uppercase leading-tight text-charcoal sm:text-[1.9rem]" data-id="element-108" data-mp="smxg8d2v9616">
            Tenés 7 días para probarlo
          </h2>
          <p className="max-w-lg font-sans text-[0.9rem] leading-relaxed text-charcoal/65 sm:text-[0.98rem]" data-id="element-109" data-mp="17i4og0pcima8">
            Accedés al sistema completo y lo usás. Si dentro de los primeros 7 días considerás que no
            es para tu forma de trabajar, podés solicitar la devolución según las condiciones
            comerciales aplicables.
          </p>
        </div>
      </div>
    </section>;
}